import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RegularUnitAdvertisementDto, SeniorUnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {MinRentPipe} from "../../pipes/min-rent.pipe";
import {MaxRentPipe} from "../../pipes/max-rent.pipe";
import {DollarPipe} from "../../pipes/dollar.pipe";
import {RelevantApartmentsInput} from "../../pipes/apartment-relevant-advertisements.pipe";

@Component({
  selector: 'homey-rent-display',
  standalone: true,
  imports: [
    MinRentPipe,
    MaxRentPipe,
    DollarPipe,
  ],
  template: `
    @let value = advertisements();
    @if (value.type === 'senior') {
      30% of gross income
    } @else {
      @let ads = value.unitTypes;
      @if (ads.length > 0) {
        @let min = ads | minRent;
        @let max = ads | maxRent;
        @if (min === max) {
          {{ (min | dollar) }} / month
        } @else {
          {{ (min | dollar) }} – {{ (max | dollar) }} / month
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RentDisplayComponent {
  advertisements = input.required<{
    type: 'senior',
    unitTypes: SeniorUnitAdvertisementDto[]
  } | {
    type: 'regular',
    unitTypes: RegularUnitAdvertisementDto[]
  }>()
  relevantAdvertisementsInput = input.required<RelevantApartmentsInput>();
}
